'use client';
import { useTranslation } from '@/hooks/useTranslation';

export default function Page() {
  const { t } = useTranslation();
  return (
    <>
      <section style={{background:'#F8FAFF',borderBottom:'1px solid #E2E8F0',padding:'56px 0 44px'}}>
        <div className="container">
          <span style={{display:'inline-block',background:'#EBF4FF',color:'#0077FF',fontSize:12,fontWeight:700,letterSpacing:'0.8px',textTransform:'uppercase',padding:'5px 14px',borderRadius:100,marginBottom:14,border:'1px solid rgba(0,119,255,0.12)'}}>{t('legal.privacy.tag')}</span>
          <h1 style={{fontFamily:"'DM Serif Display',serif",fontSize:'clamp(28px,4vw,46px)',color:'#1A202C'}}>{t('legal.cookies.heading')}</h1>
          <p style={{fontSize:14,color:'#9CA3AF',marginTop:8}}>{t('legal.updated')}</p>
        </div>
      </section>
      <section style={{background:'#fff',padding:'60px 0'}}>
        <div className="container" style={{maxWidth:760,fontSize:15,color:'#4A5568',lineHeight:1.85}}>
          <p>{t('legal.generic')}</p>
        </div>
      </section>
    </>
  );
}
